export default {
    slug: 'shippings',
    title: 'Shippings',
    visible: [
        'id',
        'provider',
        'address_name1',
        'address_street',
        'address_house_number',
        'address_city',
        'address_zip'
    ],
    listview: 'ShippingsListView',
    locales: ['common'],
    columns: [

    ],
    actions: {
        showDetails: {
            title: 'Show Details',
            level: 'row',
            vm: 'showDetails'
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/store/shippings/state.js